/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useRef, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Animation } from 'components/animation'
import { ArticleList } from 'components/articleList'
import { Question } from 'components/question'
import { QuestionDemography } from 'components/questionDemography'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import questions from '../questions.json'
import firebase from 'firebase/app'
import 'firebase/database'

// TODO Set the correct article ID here
const ARTICLE_ID = '508055421510'

export function AppComponent() {
  const isMobile = window.innerWidth < 768
  let category = -1
  const categories = [
    'Mode et beauté',
    'Bien-être et sport',
    'Culture et loisirs',
    'Cuisine et gastronomie',
    'Amis, fêtes et vie nocturne',
    'Les à-côtés',
    'C’est parti!'
  ]

  // Get the saved answers
  const localAnswers = []
  for (let i = 0; i < questions.length; i++) {
    localAnswers[i] = window.localStorage.getItem(ARTICLE_ID + '-' + i)
  }

  const questionComponents = useRef([])
  const [userId, setUserId] = useState(null)
  const [answers, setAnswers] = useState(localAnswers)
  const [age, setAge] = useState(
    window.localStorage.getItem(ARTICLE_ID + '-age')
  )
  const [sex, setSex] = useState(
    window.localStorage.getItem(ARTICLE_ID + '-sex')
  )
  const [family, setFamily] = useState(
    window.localStorage.getItem(ARTICLE_ID + '-family')
  )
  const [revenue, setRevenue] = useState(
    window.localStorage.getItem(ARTICLE_ID + '-revenue')
  )
  const [peopleAnswers, setPeopleAnswers] = useState([])

  // Init Firebase
  const config = {
    apiKey: 'AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA',
    authDomain: 'wch-interactive.firebaseapp.com',
    databaseURL: 'https://questionnaire-argent-2021.firebaseio.com/',
    projectId: 'wch-interactive',
    storageBucket: 'wch-interactive.appspot.com',
    messagingSenderId: '717470310087',
    appId: '1:717470310087:web:c2fb9c194a203ebfee68e2',
    measurementId: 'G-DEGJQ20DEE'
  }
  if (!firebase.apps.length) {
    firebase.initializeApp(config)
  }

  const gotoNextQuestion = id => {
    const nextQuestionId = (id + 1) % questions.length
    // let anchor = questionComponents[nextQuestionId]
    // scrollToComponent(anchor)
  }

  // Get the people answers
  const getAnswers = () => {
    const answers = []
    firebase
      .database()
      .ref('stories/' + ARTICLE_ID + '/questions/')
      .once('value')
      .then(snapshot => {
        snapshot.forEach(question => {
          answers[question.key] = question.val()
        })
        setPeopleAnswers(answers)
      })
  }

  const answeredDemographyHandler = (questionId, answerId, nextId) => {
    console.log(questionId + ': ' + answerId)
    setTimeout(() => {
      gotoNextQuestion(nextId)
    }, 1000)

    const userDemography = firebase
      .database()
      .ref(
        'stories/' +
          ARTICLE_ID +
          '/users' +
          '/' +
          userId +
          '/' +
          questionId +
          '/'
      )

    userDemography.transaction(
      () => {
        return answerId
      },
      (error, committed, snapshot) => {
        if (error) {
          console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          console.log('Transaction aborted')
        } else {
          console.log('Transaction complete')
          getAnswers()
        }
      }
    )

    // Save the answer in the user cache
    window.localStorage.setItem(ARTICLE_ID + '-' + questionId, answerId)
    console.log(window.localStorage)
  }

  const answeredHandler = (questionId, answerId) => {
    // Update the answers state
    const a = answers
    a[questionId] = answerId
    setAnswers(a)

    console.log('Question ' + questionId + ' answered. Answer is ' + answerId)

    // Update the answer count in Firebase
    console.log('Save in Firebase...')
    const newVote = firebase
      .database()
      .ref(
        'stories/' +
          ARTICLE_ID +
          '/questions/' +
          questionId +
          '/' +
          answerId +
          '/count/'
      )

    const userVote = firebase
      .database()
      .ref(
        'stories/' +
          ARTICLE_ID +
          '/users' +
          '/' +
          userId +
          '/questions/' +
          questionId +
          '/'
      )

    newVote.transaction(
      currentVotes => {
        return currentVotes + 1
      },
      (error, committed, snapshot) => {
        if (error) {
          console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          console.log('Transaction aborted')
        } else {
          console.log('Transaction complete')
          getAnswers()
        }
      }
    )

    userVote.transaction(
      () => {
        return answerId
      },
      (error, committed, snapshot) => {
        if (error) {
          console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          console.log('Transaction aborted')
        } else {
          console.log('Transaction complete')
          getAnswers()
        }
      }
    )

    // Save the answer in the user cache
    window.localStorage.setItem(ARTICLE_ID + '-' + questionId, answerId)
    console.log(window.localStorage)
  }

  useEffect(() => {
    // Create a new user in Firebase if first time the app is opened
    let userId = window.localStorage.getItem(ARTICLE_ID + '-userId')
    if (userId) {
      console.log('This user exists: ' + userId)
      setUserId(userId)
    } else {
      console.log('This user doesnt exist')
      const newUserEntry = firebase
        .database()
        .ref('stories/' + ARTICLE_ID + '/users/')
        .push({
          publication: parseHostname().publicationName
        })
      userId = newUserEntry.getKey()
      window.localStorage.setItem(ARTICLE_ID + '-userId', userId)
      setUserId(userId)
    }

    getAnswers()
  }, [])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Covid: quel impact sur votre argent?</h1>
            <h2>
              Avez-vous perdu votre emploi ou êtes-vous devenu millionnaire?
              Comment le Covid a-t-il impacté votre revenu, vos dépenses du
              quotidien ou votre budget chaussures? Aidez-nous à comparer votre
              situation à celles de nos lecteurs en remplissant notre
              questionnaire.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            {/* <div className='ta author'>Hans Muster</div>
              <div className='ta updated'>Actualisé le 11 avril 2021</div> */}
          </div>
          <div className='ta text'>
            Ce questionnaire a été conçu par quatre étudiants de l’UNIL et de
            l’EPFL, en partenariat avec <i>la Tribune de Genève</i>,{' '}
            <i>24 heures</i> et <i>Le Matin Dimanche</i>. Ils analyseront les
            réponses dans le cadre de{' '}
            <a href='https://edu.epfl.ch/coursebook/fr/les-donnees-en-contexte-critical-data-studies-ii-HUM-486'>
              leur programme de master
            </a>
            .
          </div>
        </div>
      </div>

      <Animation
        name='b'
        position={isMobile ? 250 : 200}
        framesCount={4}
        flip
      />
      <Animation name='b' position={isMobile ? 660 : 560} framesCount={4} />
      <Animation
        name='a'
        position={isMobile ? 900 : 910}
        framesCount={5}
        flip
      />
      <Animation name='b' position={isMobile ? 1420 : 1350} framesCount={4} />
      <Animation
        name='a'
        position={isMobile ? 1790 : 1970}
        framesCount={5}
        flip
      />
      {/* <Animation name='b' position={isMobile ? 2220 : 2370} framesCount={4} /> */}

      <div className='questions'>
        {questions.map((question, index) => {
          let articleList = null
          let categoryHeader = null
          let ageQuestion = null
          let sexQuestion = null
          let familyQuestion = null
          let revenueQuestion = null

          if (index === 3 || index === 10) {
            articleList = (
              <div
                key={'articleList-' + index}
                className='article-list-container'
              >
                <div className='ui text container'>
                  <ArticleList />
                </div>
              </div>
            )
          }

          if (index === 2) {
            sexQuestion = (
              <QuestionDemography
                key={index}
                id='sex'
                next={1}
                answer={sex}
                onAnswered={answeredDemographyHandler}
                title='Êtes-vous...'
                answers={['Un homme', 'Une femme', 'Autre']}
              />
            )
          }

          if (index === 6) {
            ageQuestion = (
              <QuestionDemography
                key={index}
                id='age'
                next={5}
                answer={age}
                onAnswered={answeredDemographyHandler}
                title='Vous avez...'
                answers={[
                  'Moins de 18 ans',
                  'Entre 18 et 35 ans',
                  'Entre 35 et 65 ans',
                  'Plus de 65 ans'
                ]}
              />
            )
          }

          if (index === 9) {
            familyQuestion = (
              <QuestionDemography
                key={index}
                id='family'
                next={8}
                answer={family}
                onAnswered={answeredDemographyHandler}
                title='Dans votre foyer, on trouve...'
                answers={[
                  'Une personne',
                  'Deux personnes',
                  'Entre 3 et 5 personnes',
                  'Plus de 5 personnes'
                ]}
              />
            )
          }

          if (index === 12) {
            revenueQuestion = (
              <QuestionDemography
                key={index}
                id='revenue'
                next={11}
                answer={revenue}
                onAnswered={answeredDemographyHandler}
                title='Quel est le revenu de votre foyer?'
                answers={[
                  'Moins de 4000 francs',
                  'Entre 4000 et 6000 francs',
                  'Entre 6000 et 10’000 francs',
                  'Plus de 10’000 francs'
                ]}
              />
            )
          }

          if (question.category !== category) {
            categoryHeader = (
              <div
                key={'categoryHeader' + index}
                className='category-header-container'
              >
                {/* <div className='category-number'>{question.category + 1}</div> */}
                {/* <img className='category-header-coin' src={require('./category-0' + (question.category + 1) + '.svg')} /> */}
                <h4 className='ui header'>{categories[question.category]}</h4>
              </div>
            )
            category = question.category
          }

          return (
            <>
              {articleList}
              {categoryHeader}
              {ageQuestion}
              {sexQuestion}
              {familyQuestion}
              {revenueQuestion}
              <div
                className='question-container'
                id={'question-' + index}
                key={'question-' + index}
              >
                <Question
                  key={index}
                  id={index}
                  questionMax={questions.length}
                  ref={questionComponents[index]}
                  onAnswered={answeredHandler}
                  result={peopleAnswers[index]}
                  answer={answers[index]}
                  title={question.title}
                  gifs={question.videoAnswers}
                  answers={question.answers}
                />
                <div className='question-number'>
                  {index + 1} / {questions.length}
                </div>
              </div>
            </>
          )
        })}
      </div>

      <Footer
        hidePortfolioTeaser
        title='Comment notez-vous cette contribution?'
        locale='fr'
        mailTo='paul.ronga@tamedia.ch'
        articleId={ARTICLE_ID}
        credits={[
          [
            'Textes',
            'Jan Briachetti, Axel Matthey, Axelle Piguet, Matthias Zeller (étudiants à l’UNIL et à l’EPFL)'
          ],
          [
            'Supervision',
            'Cécile Denayrouse, Charlotte Mazel-Cabasse (UNIL-EPFL), Paul Ronga'
          ],
          ['Conception et illustrations', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}
